export enum CateogyItemType {
	Radio = 'radio',
	Square = 'square',
}
